import { Injectable } from '@angular/core';
import { ServiceCodeHash } from '../models/service-code-hash.interface';

@Injectable()
export class ServiceMapper {

    private static _codeNamePairs:ServiceCodeHash = {};

    public static getNameFromCode(code:string):string {

        let codeLowercase:string = code.toLowerCase();

        if(!this._codeNamePairs['up']){
            this.setup();
        }

        if(this._codeNamePairs[codeLowercase]){
            return this._codeNamePairs[codeLowercase];
        } else {
            //console.error("No service name matches " + codeLowercase);
            return code;
        }

    }

    private static setup(){
        this._codeNamePairs["up"] =  "Global Entry";
        this._codeNamePairs["sh"] =  "SENTRI";
        this._codeNamePairs["fs"] =  "U.S. / Mexico FAST";
        this._codeNamePairs["fn"] =  "U.S. / Canada FAST";
        this._codeNamePairs["nh"] =  "NEXUS";
        this._codeNamePairs["ab"] =  "ABTC";
    }

}